export const storyReactionOptions = [
  { key: "like", emoji: "👍", label: "Like" },
  { key: "love", emoji: "❤️", label: "Love" },
  { key: "celebrate", emoji: "🎉", label: "Celebrate" },
  { key: "laugh", emoji: "😂", label: "Laugh" },
  { key: "remember", emoji: "🕰️", label: "Remember" },
];

export function storyDate(value) {
  if (!value) return "";
  const normalized = value.includes("T") ? value : `${value.replace(" ", "T")}Z`;
  return new Intl.DateTimeFormat("en", {
    month: "long",
    day: "numeric",
    year: "numeric",
  }).format(new Date(normalized));
}

export function reactionTotal(counts = {}) {
  return storyReactionOptions.reduce((total, option) => total + Number(counts[option.key] || 0), 0);
}

export function reactionSummary(counts = {}) {
  return storyReactionOptions.filter((option) => Number(counts[option.key] || 0) > 0);
}
